import React from "react";
import html2pdf from "html2pdf.js";
import cssClasses from "./BookingWelcomePdf.module.css";

function BookingWelcomePdf() {

  function downloadPdf() {
    const element = document.getElementById("demoPDF");
    const opt = {
      margin: [0, 0],
      filename: "Booking Welcome Price.pdf",
      html2canvas: {
        useCORS: true,
        scale: 2,
      },
      image: { type: "jpg", quality: 0.5 },
      jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      // pagebreak: { avoid: ".avoid" },
    };

    html2pdf().from(element).set(opt).save().then((res) => {
      console.log(res);
    }).catch((err) => {
      console.log(err);
    });
  }

  return (
    <>
      <div className={cssClasses.pdfContainer} id="demoPDF">

        <div className={cssClasses.pageContainer} style={{paddingTop: "20px", paddingBottom: "20px"}}>
          <div className={cssClasses.pageHeader}>
            <h1>COSTING SHEET A</h1>
            <h3>VILAS JAVDEKAR ECO HOMES</h3>
          </div>

          <div  style={{display: "flex", flexDirection: "row"}}>
            <div className={cssClasses.firstPageLeftContainer}>
              <div style={{display: "flex", flexDirection: "row", flex: 1}}>
                <div style={{display: "flex", flexDirection: "column"}}>
                  <table border="1" cellPadding="0" cellSpacing="0" >
                    <thead>
                      <tr>
                        <th colSpan={2}>VJ CENTRAL AVENUE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Building</td>
                        <td>T5</td>
                      </tr>
                      
                      <tr className={cssClasses.backgroundYellow}>
                        <td>UNIT NO</td>
                        <td>419</td>
                      </tr>
                      <tr>
                        <td>TYPE</td>
                        <td>SOHO</td>
                      </tr>
                      <tr>
                        <td>Carpet Area Sq. Ft</td>
                        <td>262</td>
                      </tr>
                      <tr>
                        <td>Saleable Area Sq.F</td>
                        <td>17</td>
                      </tr>
                      <tr>
                        <td className={cssClasses.backgroundLightOrange}>Consideration Amount*</td>
                        <td>2,734,000</td>
                      </tr>
                      <tr>
                        <td>GST</td>
                        <td>27,340</td>
                      </tr>
                      <tr>
                        <td>Total A - I</td>
                        <td>2,761,340</td>
                      </tr>
                    </tbody>
                  </table>
                  <table border="1" cellPadding="0" cellSpacing="0" >
                    <thead>
                      <tr>
                        <th colSpan={2}>BEFORE POSSESSION</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Maintenance Amount </td>
                        <td>175,000</td>
                      </tr>
                      
                      <tr className={cssClasses.backgroundYellow}>
                        <td>MNGL gas Pipe Infra charges</td>
                        <td>6,000</td>
                      </tr>
                      <tr>
                        <td>TOTAL A - II</td>
                        <td>181,000</td>
                      </tr>
                      <tr>
                        <td>Total Flat Cost A-I + A-II</td>
                        <td>2,942,340</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table border="1" cellPadding="0" cellSpacing="0" style={{flex: 1}}>
                  <thead>
                    <tr>
                      <th>Percentage</th>
                      <th>Amounts</th>
                      <th>GST&nbsp;*</th>
                      <th>TOTAL</th>
                      <th>Stages of Completion</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>10%</td>
                      <td>273,400</td>
                      <td>2,734</td>
                      <td>276,134</td>
                      <td>Booking</td>
                    </tr>
                    <tr>
                      <td>10%</td>
                      <td>273,400 </td>
                      <td>2,734 </td>
                      <td>276,134 </td>
                      <td>Completion of Building Excavation</td>
                    </tr>
                    <tr>
                      <td>10%</td>
                      <td>273,400 </td>
                      <td>2,734 </td>
                      <td>276,134 </td>
                      <td>Completion of Building Basement Raft</td>
                    </tr>
                    <tr>
                      <td>10%</td>
                      <td>273,400 </td>
                      <td>2,734</td>
                      <td>276,134 </td>
                      <td>COMPLETION OF SLAB - GROUND FLOOR</td>
                    </tr>
                    <tr>
                      <td>7%</td>
                      <td>191,380 </td>
                      <td>1,914 </td>
                      <td>193,294</td>
                      <td>COMPLETION OF FLOOR SLAB - 1ST FLOOR</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMPLETION OF FLOOR SLAB - 3RD FLOOR</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMPLETION OF FLOOR SLAB - 5TH FLOOR</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMPLETION OF FLOOR SLAB - 7th FLOOR</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMPLETION OF FLOOR SLAB - 9TH FLOOR</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMPLETION OF FLOOR SLAB -11TH FLOOR</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMPLETION OF FLOOR SLAB - ROOF</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMMENCEMENT OF FLOORING IN YOUR UNIT</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMPLETION OF EXTERNAL PLASTER / TEXTURE OF YOUR UNIT</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMPLETION OF WINDOWS / GRILL OF YOUR UNIT</td>
                    </tr>
                    <tr>
                      <td>5%</td>
                      <td>136,700 </td>
                      <td>1,367 </td>
                      <td>138,067 </td>
                      <td>COMPLETION OF FIRST COAT INTERNAL PAINTING OF YOUR UNIT</td>
                    </tr>
                    <tr>
                      <td>2%</td>
                      <td>54,680 </td>
                      <td>547 </td>
                      <td>55,227</td>
                      <td>ARCH & CIVIL COMPLETION OF APARTMENT</td>
                    </tr>
                    <tr>
                      <td>1%</td>
                      <td>27,340 </td>
                      <td>273 </td>
                      <td>27,613 </td>
                      <td>OCCUPANCY CERTIFICATE</td>
                    </tr>
                    <tr>
                      <td>100%</td>
                      <td>2,734,000 </td>
                      <td>27,340 </td>
                      <td>2,761,340 </td>
                      <td>Total</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className={cssClasses.instructionWrapper}>
                <ul>
                  <li>Taxes and duties are at prevailing rate & are subject to change.</li>
                  <li>Current mentioned Dues to be transferred / deposited in the provided Bank accounts only and have to provide transaction details thru. link. This will help us in payment tracking. All original payment receipts shall be shared post registration with Original copy of Agreement.</li>
                  <li>One single Parking is included in the package.</li>
                  <li>
                    There are provisions of EV (Electric Vehicle ) chargin points in the selected slots in the premises. You can upgrade to EV at additional cost.
                    <ol>
                      <li>Single covered EV Parking space = 2 Lacks + taxes</li>
                      <li>Single covered Composite EV Parking (Space for two scooter parking) = 3 Lacks + Taxes.</li>
                    </ol>
                  </li>
                </ul>
              </div>
            </div>
            <div className={cssClasses.firstPageRightContainer}>
              <table border="1" cellPadding="0" cellSpacing="0" >
                <thead className={cssClasses.backgroundYellow}>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Against</th>
                    <th>Amount</th>
                    <th>Received</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A</td>
                    <td>Before Agreement</td>
                    <td>1,367,000</td>
                    <td>100,000</td>
                    <td>1,267,000</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>GST on current due*</td>
                    <td>13,670</td>
                    <td>1,000</td>
                    <td>12,670</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colSpan={2}>TOTAL (A to B)</th>
                    <th>1,380,670</th>
                    <th>101,000</th>
                    <th>1,279,670</th>
                  </tr>
                </tfoot>
              </table>
              <table border="1" cellPadding="0" cellSpacing="0" >
                <thead className={cssClasses.backgroundYellow}>
                  <tr>
                    <th>IN favor of</th>
                    <th>VILAS JAVDEKAR ECO HOMES</th>
                    <th>CONSIDERATION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Account No</td>
                    <td>777705522100</td>
                    <td rowSpan={5}>1,267,000</td>
                  </tr>
                  <tr>
                    <td>Account Type</td>
                    <td>Current Account</td>
                  </tr>
                  <tr>
                    <td>Bank</td>
                    <td>ICICI Bank Ltd.</td>
                  </tr>
                  <tr>
                    <td>Branch</td>
                    <td>Kothrud, Pune</td>
                  </tr>
                  <tr>
                    <td>IFSC code</td>
                    <td>ICIC0000338</td>
                  </tr>
                </tbody>
              </table>
              <table border="1" cellPadding="0" cellSpacing="0" >
                <thead className={cssClasses.backgroundYellow}>
                  <tr>
                    <th>IN favor of</th>
                    <th>VILAS JAVDEKAR ECO HOMES</th>
                    <th>GST</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Account No</td>
                    <td>033805009998</td>
                    <td rowSpan={5}>12,670</td>
                  </tr>
                  <tr>
                    <td>Account Type</td>
                    <td>Current Account</td>
                  </tr>
                  <tr>
                    <td>Bank</td>
                    <td>ICICI Bank Ltd.</td>
                  </tr>
                  <tr>
                    <td>Branch</td>
                    <td>Kothrud, Pune</td>
                  </tr>
                  <tr>
                    <td>IFSC code</td>
                    <td>ICIC0000338</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="html2pdf__page-break"></div>

        <div className={cssClasses.pageContainer} style={{paddingTop: "20px", paddingBottom: "20px"}}>
          <div className={cssClasses.pageHeader}>
            <h1>COSTING SHEET B</h1>
            <h3>VILAS JAVDEKAR ENGINEERING SERVICES LLP</h3>
          </div>

          <div style={{display: "flex", flexDirection: "row"}}>

            <div style={{display: "flex", flexDirection: "column", flex: 1}}>
              <div style={{display: "flex", flexDirection: "row"}}>
                <table border="1" cellPadding="0" cellSpacing="0" style={{flex: 1}}>
                  <thead>
                    <tr><th colSpan={2}>COSTING SHEET A REFERENCE</th></tr>
                    <tr><th colSpan={2}>VJ CENTRAL AVENUE</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Building</td>
                      <td>T5</td>
                    </tr>
                    <tr className={cssClasses.backgroundYellow}>
                      <td>UNIT NO</td>
                      <td>419</td>
                    </tr>
                    <tr>
                      <td>TYPE</td>
                      <td>SOHO</td>
                    </tr>
                    <tr>
                      <td>Carpet Area Sq. Ft</td>
                      <td>262</td>
                    </tr>
                    <tr>
                      <td>Saleable Area Sq.Ft</td>
                      <td>17</td>
                    </tr>
                    <tr>
                      <td className={cssClasses.backgroundLightOrange}>Consideration Amount*</td>
                      <td>2734000</td>
                    </tr>
                    <tr>
                      <td className={cssClasses.backgroundLightOrange}>GST</td>
                      <td>27340</td>
                    </tr>
                    <tr>
                      <td className={cssClasses.backgroundLightOrange}>TOTAL A-</td>
                      <td>2761340</td>
                    </tr>
                  </tbody>
                </table>

                <table border="1" cellPadding="0" cellSpacing="0" style={{flex: 1}}>
                  <thead>
                    <tr><th colSpan={2}>REGISTRATION CHARGES</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Stamp duty @</td>
                      <td>191,400</td>
                    </tr>
                    <tr>
                      <td>Registration charges*</td>
                      <td> 27,400</td>
                    </tr>
                    <tr style={{fontWeight: "bolder"}}>
                      <td>TOTAL REGISTRATION</td>
                      <td>218,800</td>
                    </tr>
                    <tr>
                      <td>Legal Charges </td>
                      <td>15,000</td>
                    </tr>
                    <tr style={{fontWeight: "bolder"}}>
                      <td>Total Cost B</td>
                      <td>233,800</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className={cssClasses.instructionWrapper}>
                <ul>
                  <li>
                    Legal Charges (Inclusive GST) –
                    <ol>
                      <li>Registration at Sub-Registrar office Or E-registration At VJ Office / Site – Rs. 15,000/-</li>
                      <li>Home E-registration Within Pune – Rs. 18,000/-</li>
                      <li>Home E-registration Outside Pune – Rs. 35,000</li>
                    </ol>
                    <p>(E-registration offer shall be confirmed post validation of factors like, Location, Home loan Bank / HFC, Govt. Rules, VJ Policies etc.)</p>
                  </li>
                  <li>1% TDS will have to be deducted by home buyers having.</li>
                </ul>
              </div>
            </div>

            <div style={{display: "flex", flexDirection: "column", flex: 1}}>
              <table border="1" cellPadding="0" cellSpacing="0" style={{flex: 1}}>
                <thead className={cssClasses.backgroundYellow}>
                  <tr>
                    <th>Sr. No</th>
                    <th>Against</th>
                    <th>Amount</th>
                    <th>Received</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A</td>
                    <td>Stamp Duty & registration</td>
                    <td>218,800</td>
                    <td>149,000</td>
                    <td>69,800</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>Legal Charges *</td>
                    <td>15,000</td>
                    <td></td>
                    <td>15,000</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr className={cssClasses.backgroundLightGreen}>
                    <th colSpan={2}>TOTAL (A to B)</th>
                    <th>233,800</th>
                    <th>149,000</th>
                    <th>84,800</th>
                  </tr>
                </tfoot>
              </table>

              <table border="1" cellPadding="0" cellSpacing="0" style={{flex: 1}}>
                <thead className={cssClasses.backgroundLightGray}>
                  <tr>
                    <th></th>
                    <th>VILAS JAVDEKAR ENGINEERING SERVICES LLP</th>
                    <th>SDR</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Stamp Duty & Registration Charges</td>
                    <td>
                      <div className={cssClasses.tableLinkBox}>
                        <div>
                          <a href="https://rzp.io/l/zmFgFiF">https://rzp.io/l/zmFgFiF</a>
                        </div>
                        <p>Use above link for SDR payment</p>
                      </div>
                    </td>
                    <td>69,800</td>
                  </tr>
                </tbody>
              </table>
              <table border="1" cellPadding="0" cellSpacing="0" style={{flex: 1}}>
                <thead className={cssClasses.backgroundLightGray}>
                  <tr>
                    <th></th>
                    <th>VILAS JAVDEKAR ENGINEERING SERVICES LLP</th>
                    <th>Legal Charges</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Legal Charges</td>
                    <td>
                      <div className={cssClasses.tableLinkBox}>
                        <div>
                          <a href="https://rzp.io/l/zmFgFiF">https://rzp.io/l/zmFgFiF</a>
                        </div>
                        <p>Use above link for Legal Charges</p>
                      </div>
                    </td>
                    <td>15,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>


      <br />
      <br />
      <br />
      <button onClick={downloadPdf}>Download</button>
    </>
  );
}

export default BookingWelcomePdf;
